import { ChannelTypeEnum } from '../channel';
export var WorkflowTypeEnum;
(function (WorkflowTypeEnum) {
    WorkflowTypeEnum["REGULAR"] = "REGULAR";
    WorkflowTypeEnum["ECHO"] = "ECHO";
})(WorkflowTypeEnum || (WorkflowTypeEnum = {}));
